
export default function (Component) {
  Component.options.__source = "src/views/decision/PavementMaintenancePlanningScheme/IndicatorsDuringThePlanningPeriod/index.vue"
}
